import { useDispatch, useSelector } from "react-redux";
import { toggleAccionDesarrolloPlantelActiveThunk } from "../../../store/reducers/fortalezas/fortalezasPlantel.thunks";
import Modal from "../../UI/Modal";
import Loader from "../../UI/Loader";
import { closeAccionConfirmToggle } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";

const ConfirmToggleAccionModalPlantel = () => {
  const dispatch = useDispatch();
  const { accionConfirmModalOpen, toggleAccionId, accionToggling } = useSelector((state) => state.fortalezasPlantel);
  const accion = useSelector((state) => state.fortalezasPlantel.accionesList.find((a) => a.id === toggleAccionId));

  return (
    <Modal open={accionConfirmModalOpen} onClose={() => dispatch(closeAccionConfirmToggle())} title="Confirmación" size="sm">
      {accionToggling ? <Loader center text="Actualizando..." type="dots" size="sm" /> : (
        <>
          <p className="mb-3">¿Seguro que quieres <strong>{accion?.is_active ? "desactivar" : "activar"}</strong> la acción <strong>"{accion?.frase}"</strong>?</p>
          <div className="d-flex justify-content-end gap-2">
            <button className="btn btn-secondary" onClick={() => dispatch(closeAccionConfirmToggle())}>Cancelar</button>
            <button className="btn btn-primary" onClick={() => dispatch(toggleAccionDesarrolloPlantelActiveThunk(toggleAccionId))}>Confirmar</button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ConfirmToggleAccionModalPlantel;
